<template>
  <div :id="key" class="spark" role="button" @click="$emit('click')"></div>
</template>

<script>
import { v4 as uuid } from "uuid";
import ontick_colors from "../../../shared/utils/ontick_colors";
export default {
  props: {
    symbol: {
      type: String,
    },
    padding: {
      type: Number,
      default: 8,
    },
    dataset: {
      type: Array,
      default: () => {
        let arr = [10000];

        for (let i = 1; i < 1800; i++) {
          if (Math.random() <= 0.5) {
            arr.push(arr[i - 1] - Math.random() * 100);
          } else {
            arr.push(arr[i - 1] + Math.random() * 100);
          }
        }

        return arr;
      },
    },
  },

  data() {
    return {
      key: uuid(),
    };
  },

  methods: {
    mountChart(dataset) {
      // Test dataset
      if (Math.random() < 0.5) {
        dataset = dataset.reverse();
      }

      // Initializes
      const container = document.getElementById(this.key);
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const padding = this.padding;
      const width = container.offsetWidth - padding * 4;
      const height = container.offsetHeight;
      const max_value = Math.max(...dataset);
      const min_value = Math.min(...dataset);
      const horizontal_interval = width / dataset.length;
      const values_to_height = dataset.map((value) => {
        if (!value) return 0;
        return ((value - min_value) / (max_value - min_value)) * (height - padding * 2);
      });
      const { green, orange, steel } = ontick_colors;

      // Resets container
      container.innerHTML = "";

      // Configures canvas
      canvas.width = width;
      canvas.height = height;

      ctx.scale(1, 1);
      ctx.beginPath();
      ctx.translate(0.5, 0.5);

      let color = steel[600];
      if (values_to_height[0] < values_to_height[values_to_height.length - 1]) {
        color = green[600];
      }
      if (values_to_height[0] > values_to_height[values_to_height.length - 1]) {
        color = orange[600];
      }

      ctx.lineCap = "round";
      ctx.lineWidth = 1;
      ctx.strokeStyle = color;

      // Draws
      for (let i = 0; i < values_to_height.length; i++) {
        ctx.moveTo(horizontal_interval * i + padding / 2, height - (values_to_height[i] + padding));
        if (i + 1 < values_to_height.length) {
          ctx.lineTo(horizontal_interval * (i + 1) + padding / 2, height - (values_to_height[i + 1] + padding));
          ctx.stroke();
        }
      }

      // Mounts
      container.appendChild(canvas);
    },
    resizeListener() {
      this.mountChart(this.dataset);
    },
  },

  mounted() {
    window.addEventListener("resize", this.resizeListener);
    this.mountChart(this.dataset);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.resizeListener);
  },
};
</script>

<style lang="scss" scoped>
.spark {
  @apply max-h-12 flex items-center justify-center w-[100px] hover:brightness-125 active:brightness-75 transition-all;
}
</style>
